import React, { useState } from 'react';
import { history, useParams, useIntl } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

// 子tab
import MobileStoreRankTop from './page/alltopcharts';
import GlobalCompareTab from './page/globalcompare';

import { getValidActiveId } from '@/pages/intelligence/utils/commonUtils';

import '@/pages/intelligence/assets/scss/StoreRanks/MobileGlobalRegion/index.scss';

import type { IBaseProps } from '@/pages/intelligence/types/common';

const { Content } = Layout;

type IMobileStoreRanksTabId = 'alltopcharts' | 'globalcompare' | (string & {});

type IMobileStoreRanksProps = IBaseProps;

const MobileStoreRanks: React.FC<IMobileStoreRanksProps> = (props) => {
  const {} = props;

  const { formatMessage } = useIntl();

  const { tab: pathActiveId } = useParams<any>();

  const tabs = [
    {
      id: 'alltopcharts', // MobileStoreRankTop
      label: formatMessage({ id: 'dbi_store_rank_all_top_charts' }),
      component: MobileStoreRankTop,
    },
    {
      id: 'globalcompare', // GlobalCompare
      label: formatMessage({ id: 'dbi_store_rank_global_compare' }),
      component: GlobalCompareTab,
    },
  ];

  const initialActiveId = getValidActiveId(pathActiveId, {
    tabs,
    defaultActiveId: 'alltopcharts',
  });

  const [activeId, setActiveId] =
    useState<IMobileStoreRanksTabId>(initialActiveId);

  const handleActive = (tab: { id: IMobileStoreRanksTabId }) => {
    setActiveId(tab?.id);
    history.replace(`/intelligence/storeRanks/MobileGlobalRegion/${tab?.id}`);
  };

  return (
    <Content className="dbi-page dbi-storeranks--mobile">
      <Content.Header
        className="dbi-header contentHead-normal"
        title={formatMessage({ id: 'dbi_store_rank_mobile_global_region' })}
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="StoreRanksMobileGlobal/Region"
            animated={false}
            tabs={tabs}
            activeId={activeId}
            onActive={handleActive}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        <MarqueeBanner />
        {tabs?.map((tab) => (
          <div key={tab?.id}>{tab?.id === activeId && <tab.component />}</div>
        ))}
      </Content.Body>
    </Content>
  );
};

export default MobileStoreRanks;
